<template>
  <div>
    <el-card>
      <div class="notice-detail">
        <div class="list">
          <el-row type="flex" class="list-item">
            <!-- <el-col :span="1" :key="newsDetail.avatar">
                            <img class="avater" :src='newsDetail.avatar ? newsDetail.avatar :"https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif"' alt="">
                        </el-col> -->
            <el-col :span="24">
              <h3 class="mb15" :key="newsDetail.title">
                {{ newsDetail.title }}
              </h3>
              <div class="newsDetail_flex">
                <img
                  class="avater"
                  :src="
                    newsDetail.avatar
                      ? newsDetail.avatar
                      : 'https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif'
                  "
                  alt=""
                />
                <strong class="newsDetail_oper" :key="newsDetail.operator">{{
                  newsDetail.operator
                }}</strong>
                <div class="newsDetail_time" :key="newsDetail.createTime">
                  {{ newsDetail.createTime }}
                </div>
              </div>
              <div style="margin-top: 10px">
                <article v-html="newsDetail.content"></article>
                <div
                  v-if="toDomainList && toDomainList.length > 0"
                  class="newsDetail_box"
                >
                  <div
                    v-for="(item, index) in toDomainList"
                    :key="index"
                    class="newsDetail_a"
                  >
                    {{ item.examSettingName }}
                    ({{ item.examSettingPeriod[0] }} {{ item.examSettingPeriod[1] }} ~
                    {{ item.examSettingPeriod[0] }} {{ item.examSettingPeriod[2] }})
                    <el-link type="primary" :href="item.url" target="_blank"
                      >点击此处跳转考试>>></el-link
                    >
                  </div>
                </div>
                <div v-if="toChapterDomain" class="newsDetail_a">
                  <span>试题或录播</span>
                  <el-link type="primary" :href="toChapterDomain" target="_blank"
                    >点击此处跳转学习>>></el-link
                  >
                </div>
                <div v-if="toPovDomainList" class="newsDetail_a">
                  <div
                    v-for="(item, index) in toPovDomainList"
                    :key="index"
                    class="newsDetail_a"
                  >
                    {{ item.name }}
                    <span v-if="item.livePeriod && item.livePeriod.length > 0">
                      ({{ item.livePeriod[0] }} {{ item.livePeriod[1] }} ~
                      {{ item.livePeriod[0] }} {{ item.livePeriod[2] }})
                    </span>
                    <span>(直播)</span>
                    <el-link type="primary" :href="item.url" target="_blank"
                      >点击此处直播>>></el-link
                    >
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "notice-detail",

  data() {
    return {
      id: "",
      newsDetail: "",
      domain: "",
      toDomain: "",
      toChapterDomain: "",
      toPovDomainList: [],
      toDomainList: [],
    };
  },

  methods: {
    getNoticeDetail() {
      this.api.user.getNotice({ id: this.$route.query.id }).then((res) => {
        this.toDomainList = [];
        this.toPovDomainList = [];
        let toChapterDomainBlock = true;
        if (res.success) {
          this.newsDetail = res.data;
          if (this.newsDetail.sendDest === 3) {
            this.newsDetail.noticeGoodsList.forEach((e) => {
              e.goodsInfo.goodsItemList.forEach((f) => {
                if (f.type === "考试") {
                  let tempUrl =
                    this.domain +
                    `/student/exercisePage?examSettingId=${f.examSettingId}&name=${f.examSettingName}&subjectName=${f.courseName}`;
                  this.toDomainList.push({
                    url: tempUrl,
                    examSettingPeriod: f.examSettingPeriod,
                    examSettingName: f.examSettingName,
                  });
                }
                if ((f.type === "题库" || f.type === "录播") && toChapterDomainBlock) {
                  this.toChapterDomain = this.domain + "/student/attendClass";
                }
                if (f.type === "直播") {
                  this.toPovDomainList.push({
                    name: f.name,
                    url: f.pcViewUrl,
                    livePeriod: f.livePeriod,
                  });
                  console.log(this.toPovDomainList);
                  // this.getPolyvChannel(f.objectId)
                }
              });
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getPolyvChannel(id) {
      this.api.polyvChannel.getPolyvChannel({ id: id }).then((res) => {});
    },
    getGeneralSetting() {
      this.api.generalSetting.getGeneralSetting().then((res) => {
        if (res.data.domain) {
          if (res.data.domain.indexOf("http") > -1) {
            this.domain = res.data.domain;
          } else {
            this.domain = "http://" + res.data.domain;
          }
        }
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getGeneralSetting();
    this.getNoticeDetail();
  },
};
</script>
<style lang="less">
.mb20 {
  margin-bottom: 20px;
}
.newsDetail_flex {
  display: flex;
  color: #9b9b9b;
  line-height: 25px;
}
.newsDetail_oper {
  margin-left: 10px;
}
.newsDetail_time {
  margin-left: 10px;
}
.newsDetail_box {
  margin-top: 20px;
}
.newsDetail_a {
  margin-top: 10px;
}
.notice-detail {
  margin: auto;
  width: 60%;
}
.notice-detail {
  .mb15 {
    font-size: 18px;
    // margin-bottom: 15px;
  }
  .list-item {
    margin-bottom: 10px;
    img.avater {
      width: 25px;
      height: 25px;
      border-radius: 100%;
    }
    strong {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notice/noticeDetail.vue